import { defineComponent as _defineComponent } from 'vue'
import EmptyContent from "@/components/shared/EmptyContent.vue";
import { IGuideInfoData } from "@/domain/entities/guide";
import DOMPurify from "dompurify";
import { PropType, ref } from "vue";
import ScrollTopControl from "../shared/ScrollTopControl.vue";


const __default__ = {
  name: "Tutorial",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  guideInfo: {
    type: Object as PropType<IGuideInfoData>,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();



const scrollContainerRef = ref<HTMLElement>();

const __returned__ = { scrollContainerRef, EmptyContent, get DOMPurify() { return DOMPurify }, ScrollTopControl }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})